module.exports = __webpack_public_path__ + "img/megan-rapinoe.e18d9f27.png";